import { FOOD_LEGACY_RESET } from '../actions/food';

/**
 * The calendar and meal ideas slices hold UI state about the budget the food store is showing: the
 * active list's draft, the idea open in its popup, changes shown ahead of their save. When the store
 * moves to another user or budget by a route other than a budget switch (a cached player answer, a
 * sign-in as someone else, a logout), they are told to empty it, FOOD_LEGACY_RESET, as they empty
 * themselves on CHANGE_ACTIVE_BUDGET_SUCCESS.
 *
 * Starts on `store`, which must offer `onAction(listener)` (configureStore's does). Returns a function
 * that stops it.
 */
export function startLegacyReset(store) {
	const identityOf = (food) => ({ userId: food.userId, budgetId: food.budgetId });
	let held = identityOf(store.getState().food);
	return store.onAction(() => {
		const next = identityOf(store.getState().food);
		const was = held;
		held = next;
		if((next.userId !== was.userId || next.budgetId !== was.budgetId) && was.budgetId !== null) {
			store.dispatch({ type: FOOD_LEGACY_RESET });
		}
	});
}
